import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { withPageContext } from '../../utils/PageContext/PageContext';
import { DropdownItem } from '../../components/DropdownItem/DropdownItem';

const InspirationalSearchSelector = ({
    trackEvent,
    onClickItem,
    trackAutocompleteSourceState,
    trackAutocompleteSourceSelection,
}) => {
    const { t } = useTranslation();
    useEffect(() => {
        trackAutocompleteSourceState({
            source: 'popular',
            state: 'shown',
            queryLength: 0,
        });
    }, [trackAutocompleteSourceState]);

    const getInspirationalText = () => {
        const title = t('inspirational.airportselector.title');
        const subtitle = t('inspirational.airportselector.subtitle');
        return `${title} ${subtitle}`;
    };

    const handleClickItem = () => {
        const inspirationalText = getInspirationalText();
        const value = {
            city: inspirationalText,
            name: inspirationalText,
            iata: 'INSP',
            geoNodeId: 0,
            geoNodeType: 'CITY',
            type: 'CITY',
            countryCode: '',
        };
        trackAutocompleteSourceSelection({
            source: 'popular',
            position: undefined,
            queryLength: 0,
        });
        onClickItem(value);
        trackEvent({ action: 'searcher_flights', label: 'picker:arrival_sel:anywhere' });
    };
    const inspirationalText = getInspirationalText();
    return (
        <DropdownItem onClick={handleClickItem} iconClass="odf-icon-compass odf-text-action">
            {inspirationalText}
        </DropdownItem>
    );
};

InspirationalSearchSelector.propTypes = {
    onClickItem: PropTypes.func.isRequired,
    trackEvent: PropTypes.func.isRequired,
    trackAutocompleteSourceState: PropTypes.func,
    trackAutocompleteSourceSelection: PropTypes.func,
};

InspirationalSearchSelector.defaultProps = {
    trackAutocompleteSourceState: () => {},
    trackAutocompleteSourceSelection: () => {},
};

const connected = withPageContext(InspirationalSearchSelector);
export { connected as InspirationalSearchSelector };
